import { mockCameras } from "./mock-cameras";
import { type Site } from "../domain/site";

export const mockSite = (siteId: string): Site => {
  const cameras = mockCameras("eval-site");
  const firstCamera = cameras[0];
  if (!firstCamera) {
    throw new Error("mockCameras must return at least one camera");
  }
  return {
    id: siteId,
    name: "Evaluation Site",
    description: "Mock site for evaluation",
    cameras,
    cameraCount: cameras.length,
    address: "123 Example St, Testville",
    timezone: firstCamera.timeZone,
    openHoursSummary: "Mon-Fri 09:00-17:00",
  };
};
